var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "reloj@1x-a",
          d:
            "M12.5,4.819 C16.7245,4.819 20.15,8.2445 20.15,12.469 C20.15,16.6935 16.7245,20.119 12.5,20.119 C8.267,20.119 4.85,16.6935 4.85,12.469 C4.85,8.2445 8.2755,4.819 12.5,4.819 Z M12.5,6.519 C9.2105,6.519 6.55,9.1795 6.55,12.469 C6.55,15.7585 9.2105,18.419 12.5,18.419 C15.7895,18.419 18.45,15.7585 18.45,12.469 C18.45,9.1795 15.7895,6.519 12.5,6.519 Z M12.925,8.219 L12.925,12.6815 L16.325,14.696 L15.6875,15.7415 L11.65,13.319 L11.65,8.219 L12.925,8.219 Z M17.09,3 L21,6.281 L19.9035,7.5815 L15.9935,4.3005 L17.09,3 Z M7.91,3 L8.998,4.3005 L5.0965,7.573 L4,6.2725 L7.91,3 Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: { fill: "currentColor", "xlink:href": "#reloj@1x-a" }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }